'use client';

import { ChevronLeft, FileText } from 'lucide-react';
import { useTranslations, useLocale } from 'next-intl';
import { useRouter } from 'next/navigation';

export default function TermsClient() {
  const t = useTranslations();
  const locale = useLocale();
  const router = useRouter();
  const isRTL = locale === 'ar';

  return (
    <div
      className="w-full max-w-3xl mx-auto px-4 py-8 animate-in fade-in slide-in-from-bottom-4 duration-500"
      data-testid="terms-of-use"
    >
      <div className="flex items-center gap-4 mb-8">
        <button
          onClick={() => router.back()}
          className="p-2 rounded-full hover:bg-secondary transition-colors cursor-pointer"
          data-testid="terms-back"
          aria-label={t('btn_back')}
        >
          <ChevronLeft className={`w-6 h-6 ${isRTL ? 'rotate-180' : ''}`} />
        </button>
        <div className="flex items-center gap-2">
          <FileText className="w-6 h-6 text-primary" />
          <h1 className="text-2xl font-bold">{t('terms_title')}</h1>
        </div>
      </div>

      <div className="bg-card border border-border rounded-2xl p-6 md:p-8 shadow-sm space-y-6">
        <p className="text-muted-foreground text-sm">
          {t('terms_last_updated')}: {t('terms_date')}
        </p>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">{t('terms_acceptance_title')}</h2>
          <p className="text-foreground/80 leading-relaxed">{t('terms_acceptance_text')}</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">{t('terms_description_title')}</h2>
          <p className="text-foreground/80 leading-relaxed">{t('terms_description_text')}</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">{t('terms_disclaimer_title')}</h2>
          <p className="text-foreground/80 leading-relaxed">{t('terms_disclaimer_text')}</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">{t('terms_ip_title')}</h2>
          <p className="text-foreground/80 leading-relaxed">{t('terms_ip_text')}</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">{t('terms_liability_title')}</h2>
          <p className="text-foreground/80 leading-relaxed">{t('terms_liability_text')}</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">{t('terms_changes_title')}</h2>
          <p className="text-foreground/80 leading-relaxed">{t('terms_changes_text')}</p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-foreground">{t('terms_contact_title')}</h2>
          <p className="text-foreground/80 leading-relaxed">{t('terms_contact_text')}</p>
        </section>
      </div>
    </div>
  );
}
